import { ValueNoneIcon } from '@radix-ui/react-icons';
import { Button } from '@radix-ui/themes';
import { useNavigate } from 'react-router-dom';

export const ErrorBox: React.FC<{
  errorType: string;
  errorTitle: string;
  errorMessage: string;
}> = ({ errorType, errorTitle, errorMessage }) => {
  const navigate = useNavigate();
  return (
    <div
      id='container'
      className='border-neutral-neutral-3 bg-neutral-neutral-1 mt-4 flex max-w-80 flex-col items-start gap-4 self-stretch rounded-2xl border border-solid p-3'
    >
      <div id='error' className='flex flex-col items-start gap-4 self-stretch'>
        <div className='flex items-center gap-2 self-stretch'>
          <div id='icon' className='flex h-8 w-8 items-center gap-2 self-stretch fill-transparent'>
            <ValueNoneIcon width='32' height='32' color='#E2A336' />
          </div>
          <div className='text-neutral-neutral-12 text-sm font-medium'>{errorType}</div>
        </div>
        <div className='text-neutral-neutral-12 text-lg leading-6 font-bold'>{errorTitle}</div>
        <div className='text-neutral-neutral-12 text-sm font-normal'>{errorMessage}</div>
      </div>
      <div id='separator' className='bg-neutral-neutral-4 flex h-px self-stretch'></div>
      <div id='back' className='flex w-full items-center justify-between gap-4'>
        <div id='text'>Vuoi tornare indietro?</div>
        <div id='back'>
          <Button size='2' variant='soft' color='gray' onClick={() => navigate(-1)}>
            Torna indietro
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ErrorBox;
